// hooks/usePhoneNumber.js
import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export const usePhoneNumber = () => {
  const location = useLocation();

  // Define your phone numbers
  const defaultPhone = "+971 54 232 1797";
  const categoryPhone = "+971 54 232 1797";

  // Keywords for special categories (handles both singular and plural forms)
  const categoryKeywords = [
    "telehandler",
    "telehandlers",  // Added plural form for static page route
    "skid-steer",
    "mini-excavator",
    "mini-excavators"  // Added plural form
  ];

  // Detect if current route or product belongs to special categories
  const isSpecialCategory = useMemo(() => {
    const path = location.pathname.toLowerCase();

    // Check if path includes any special category keyword
    return categoryKeywords.some(keyword => path.includes(keyword));
  }, [location.pathname]);

  // Handle query params for product attribute pages
  const searchParams = new URLSearchParams(location.search);
  const paCategory = searchParams.get("pa_categories");
  const matchesQuery = categoryKeywords.some(keyword => paCategory?.toLowerCase().includes(keyword));

  return (isSpecialCategory || matchesQuery) ? categoryPhone : defaultPhone;
};